(function() {
    "use strict";

    angular
        .module('iMatApp')
        .directive('delayOverlay', ['$timeout',
            function($timeout) {
                return {
                    scope: {
                        delay: '@delayOverlay',
                        show: '='
                    },
                    restrict: 'A',
                    transclude: true,
                    template: '<div ng-class=\"{\'display-overlay\': isDisplayedProgress}\"><div ng-transclude></div></div>',
                    link: function(scope, element, attrs) {
                        var promise = null;
                        scope.isDisplayedProgress = false;

                        scope.$watch("show", function(newValue, oldValue) {

                            if (newValue === oldValue)
                                return;

                            if (newValue && !promise) {
                                promise = $timeout(function() {

                                    scope.isDisplayedProgress = true;

                                }, scope.delay);
                            }

                            if (!newValue && promise) {

                                $timeout.cancel(promise);
                                promise = null;
                                scope.isDisplayedProgress = false;
                            }
                        });
                    }
                };
            }
        ]);
})();